<template>
  <docs-list></docs-list>
</template>

<script>
import DocsList from '@/components/DocsList'
export default {
  name: 'PageDocs',
  components: {
    DocsList,

  },
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  },
}
</script>
